var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M5.0625 19.9083V6.09167C5.0625 3.28824 7.32958 1.01562 10.1262 1.01562H7.04297C4.23837 1.01562 1.96484 3.28915 1.96484 6.09375V19.9062C1.96484 22.7108 4.23837 24.9844 7.04297 24.9844H10.1262C7.32958 24.9844 5.0625 22.7118 5.0625 19.9083Z",
    fill: "url(#paint0_linear_724_48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 26H6.09375C2.73366 26 0 23.2663 0 19.9062V6.09375C0 2.73366 2.73366 0 6.09375 0H17.4375C20.7976 0 23.5312 2.73366 23.5312 6.09375V19.9062C23.5312 23.2663 20.7976 26 17.4375 26ZM6.09375 2.03125C3.85369 2.03125 2.03125 3.85369 2.03125 6.09375V19.9062C2.03125 22.1463 3.85369 23.9688 6.09375 23.9688H17.4375C19.6776 23.9688 21.5 22.1463 21.5 19.9062V6.09375C21.5 3.85369 19.6776 2.03125 17.4375 2.03125H6.09375ZM18.418 9.34375C18.418 8.78282 17.9633 8.32812 17.4023 8.32812H15.6758C14.8358 8.32812 14.1523 7.64471 14.1523 6.80469V5.07812C14.1523 4.5172 13.6976 4.0625 13.1367 4.0625C12.5758 4.0625 12.1211 4.5172 12.1211 5.07812V6.80469C12.1211 8.76474 13.7157 10.3594 15.6758 10.3594H17.4023C17.9633 10.3594 18.418 9.90468 18.418 9.34375Z",
    fill: "url(#paint1_linear_724_48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.807 19.6524C9.9616 19.6524 9.16734 19.3208 8.5704 18.7187L6.62639 16.7579C6.23152 16.3596 6.23426 15.7166 6.63259 15.3216C7.03097 14.9267 7.67396 14.9296 8.06889 15.3278L10.0128 17.2886C10.2254 17.503 10.5075 17.6211 10.807 17.6211C11.1065 17.6211 11.3885 17.503 11.6011 17.2886L15.6155 13.249C16.011 12.851 16.654 12.8492 17.0518 13.2444C17.4497 13.6398 17.4517 14.2829 17.0564 14.6807L13.0428 18.7195C12.4466 19.3208 11.6524 19.6524 10.807 19.6524Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_724_48",
    x1: 1.96484,
    y1: 1.01562,
    x2: 17.8675,
    y2: 8.47032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_724_48",
    x1: 0,
    y1: 0,
    x2: 21.9108,
    y2: 27.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.96ef8244023cf56ae69b94aba91ff0ae.svg";
export { ForwardRef as ReactComponent };